import { GetFaqServices } from "./service";
import { toast } from "react-toastify";

import {
 
  FAQ_PAGE_DATA,
} from "../../common/constants/actionConstants";

import { isLoading } from "../../common/dependencies/action/action";



export const getFaqDataList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindMentorFormData (params).then((data) => {
    // 
    const { getFaqDataList } = data;
    if (getFaqDataList) {
      dispatch({
        type: FAQ_PAGE_DATA,
        payload: getFaqDataList,
      });
    }
    dispatch(isLoading(false));
  });
};



async function getBindMentorFormData() {
 
    const getFaqDataList =
    await GetFaqServices.getFaqDataList().catch((e) => {
      return { data: [], status: false };
    });

  return {  
    getFaqDataList,};
}
